import StaffDashboard from './pages/Staff/Dashboard/index'
import Top from './pages/Landing/Top/index'
import Recipe from './pages/Landing/Recipe/index'
import Company from './pages/Landing/Company/index'
import Contact from './pages/Landing/Contact/index'
import ContactDanke from './pages/Landing/ContactDanke/index'
import Ingredients from './pages/Landing/Ingredients/index'
import Privacy from './pages/Landing/Privacy/index'
import Dlg from './pages/Landing/Dlg/index'
import Cart from './pages/Landing/Cart/index'
import CartConfirm from './pages/Landing/CartConfirm/index'
import CartDanke from './pages/Landing/CartDanke/index'
import Guide from './pages/Landing/Guide/index'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VScrollLock from 'v-scroll-lock'
import VueAnalytics from 'vue-analytics'

// Configuration VueAnalytics
Vue.use(VueAnalytics, {
  id: 'UA-754684-1'
})

Vue.use(VScrollLock)
Vue.use(VueScrollTo)

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

export default [
  {
    path: '/dashboard',
    redirect: '/top'
  },
  {
    path: '/staff/dashboard',
    name: 'staff_dashboard',
    component: StaffDashboard,
    meta: { requiresAuth: true, requiresRoles: ['user'], layout: 'app-layout-default', applicationClasses: ['application-biz'] }
  },
  {
    path: '/top',
    name: 'top',
    component: Top,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/recipe',
    name: 'recipe',
    component: Recipe,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/company',
    name: 'company',
    component: Company,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/contact_danke/:id',
    name: 'contact_danke',
    component: ContactDanke,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/ingredients',
    name: 'ingredients',
    component: Ingredients,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/dlg',
    name: 'dlg',
    component: Dlg,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/cart_confirm',
    name: 'cart_confirm',
    component: CartConfirm,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/cart_danke/:id',
    name: 'cart_danke',
    component: CartDanke,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  },
  {
    path: '/guide',
    name: 'guide',
    component: Guide,
    meta: { requiresAuth: false, layout: 'app-layout-simple' }
  }
]



// WEBPACK FOOTER //
// ./src/app/routes.js